import { RequirementsMatch } from '@/Jobs/helpers/constants'

export const matchLabel = {
  [RequirementsMatch.Role]: 'Role',
  [RequirementsMatch.RoleExperience]: 'Experience in role',
  [RequirementsMatch.MustHaveSkills]: 'All must-have skills',
  [RequirementsMatch.RemotePolicyAndLocation]: 'Remote policy and location',
  [RequirementsMatch.VisaRequirements]: 'Visa requirements',
  [RequirementsMatch.EmploymentType]: 'Employment type',
}
